import type { Tournament } from '@flow/core';
import { run, useDeps, useUseCases } from '../../app/services';

/** Asks first; says exactly how much goes away. Resolves true if it was deleted. */
export const useDeleteTournament = () => {
  const deps = useDeps();
  const uc = useUseCases();
  return async (t: Tournament) => {
    const n = (await deps.rounds.listByTournament(t.id)).length;
    const what = n === 0 ? 'It has no rounds.' : `This deletes its ${n} round${n === 1 ? '' : 's'}, with their flows and ballots.`;
    if (!confirm(`Delete "${t.name}"? ${what} This can't be undone.`)) return false;
    return !!(await run(uc.deleteTournament(t.id)));
  };
};
